module.exports = __webpack_public_path__ + "static/media/piper-mic.e9ab97ea.svg";